import { useLocationHistory } from 'util/hooks/useLocationHistory'
import { push } from 'connected-react-router'
import { useDispatch } from 'react-redux'

export const useReturnToLastUrl = (onHideURL: string | undefined) => {
	const dispatch = useDispatch()
	const { history } = useLocationHistory()

	if (!onHideURL) {
		return {
			shouldReturnToLast: false,
			targetUrl: null,
			navigateBack: () => {},
		}
	}

	const lastUrl = history[history.length - 1]

	const lastUrlPath = lastUrl
		? `${lastUrl.pathname}${lastUrl.search || ''}${lastUrl.hash || ''}`
		: null

	const shouldReturnToLast = lastUrlPath && lastUrlPath !== onHideURL
	const targetUrl = shouldReturnToLast ? lastUrlPath : onHideURL

	const navigateBack = () => {
		if (targetUrl) {
			dispatch(push(targetUrl))
		}
	}

	return { shouldReturnToLast, targetUrl, navigateBack }
}
